var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg92 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "nonzero",
  d: "M11.698 12.6a.8.8 0 0 1 0-1.6h15.594a.8.8 0 1 1 0 1.6zm0 19.392a.8.8 0 1 1 0-1.6h15.594a.8.8 0 0 1 0 1.6zm0-9.696a.8.8 0 1 1 0-1.6h15.594a.8.8 0 1 1 0 1.6zm7.597 4.898a.8.8 0 1 1 0-1.6H32.29a.8.8 0 1 1 0 1.6zm-12.495 0a.8.8 0 1 1 0-1.6h7.997a.8.8 0 0 1 0 1.6zm0-9.696a.8.8 0 0 1 0-1.6h12.995a.8.8 0 0 1 0 1.6zm17.493 0a.8.8 0 0 1 0-1.6h7.997a.8.8 0 1 1 0 1.6z"
})));
export { Svg92 as ReactComponent };